
















































import { Component, Vue, Prop } from 'vue-property-decorator';
import VehicleDetail from '@/models/VehicleDetail';
import CarDetail from '@/components/CarDetail.vue';
import Configuration from '@/components/Configuration.vue';
import { SelectedAttributeModel } from '../models/AttributeModel';

@Component({
  name: 'MatSelector',
  components: {
    CarDetail,
    Configuration,
  },
})
export default class MatSelector extends Vue {
  @Prop()
  public vehicleDetail!: VehicleDetail;
  private gotoStep: number = 3;
  private windowWidth: number = 0;

  private created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    if (!this.vehicleDetail) {
      this.$emit('clickContinue', 2);
    }
  }

  private setSelectedAttributes(selectedAttributes: SelectedAttributeModel[]) {
    const data = {
      selectedAttributes,
      gotoStep: this.gotoStep,
    };
    this.$emit('setSelectedAttributes', data);
  }

  private handleResize() {
    this.windowWidth = window.innerWidth;
  }

  private destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }
}
